var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page",attrs:{"id":"choose-popular-buttons-page"}},[(_vm.menuOpen)?[_c('div',{staticClass:"block-screen",attrs:{"id":"blockScreen"},on:{"click":_vm.closeMenu}})]:_vm._e(),_c('Menu'),_c('RemoteHeader',{attrs:{"heading":_vm.$t('choosePopularButtonsPageHeader')}}),_c('div',{},[_c('ChoosePopularButtons')],1)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }